import PathwayViewer from "../containers/PathwayViewer";
import Main from "../components/layout/Main";
import React from "react";

export const PathwayViewerPage = () => {
    return <Main title="Pathway Viewer"><PathwayViewer /></Main>
}